var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col sortable",class:_vm.containerClass,on:{"click":function($event){$event.preventDefault();return _vm.toggleDateSort.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.headerTitle())+"\n  "),_c('i',{staticClass:"fas fa-sort",class:{
      'text-muted': _vm.locallySorted && _vm.dateRangeType === _vm.activeDateType,
      'fa-sort-up': _vm.dateRangeType === _vm.activeDateType && _vm.sortDirection === 'asc',
      'fa-sort-down': _vm.dateRangeType === _vm.activeDateType && _vm.sortDirection === 'desc'
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }